var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairCError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M19.692 14h20.825v15.643H19.692V14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M46 30.455C46 39.04 39.04 46 30.454 46h-.909C20.96 46 14 39.04 14 30.454A3.455 3.455 0 0 1 17.454 27h25.091A3.455 3.455 0 0 1 46 30.455Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m13 21.334.286-2.042a5.883 5.883 0 0 1 5.826-5.069h21.776a5.883 5.883 0 0 1 5.827 5.069L47 21.334"
})));
SvgNoTableChairCError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairCError);
export default ForwardRef;